import { Injectable, EventEmitter, NgZone } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleAuthService {
  clientId = environment.googleClientId;
  loginError = new EventEmitter<string>();

  constructor(private api: ApiService, private zone: NgZone) {}

  initializeGoogle(): void {
    if (typeof (window as any).google === 'undefined') {
      console.warn('Google Identity Services script not loaded');
      this.loginError.emit('generic');
      return;
    }

    (window as any).handleGoogleCredentialResponse = (response: any) => {
      // Google's callback runs outside Angular's zone, so change detection
      // would otherwise only run on the next unrelated Angular event.
      this.zone.run(() => this.handleCredentialResponse(response));
    };

    const onloadElement = document.getElementById('g_id_onload');
    if (onloadElement) {
      onloadElement.setAttribute('data-client_id', this.clientId);
      onloadElement.setAttribute('data-callback', 'handleGoogleCredentialResponse');
      (window as any).google.accounts.id.initialize({
        client_id: this.clientId,
        callback: (window as any).handleGoogleCredentialResponse
      });
      (window as any).google.accounts.id.renderButton(
        document.querySelector('.g_id_signin'),
        { theme: 'outline', size: 'large' }
      );
    }
  }

  
async handleCredentialResponse(response: { credential: string }) {
  try {
    const idToken = response.credential;

    console.log('Google login started, Token ID:', idToken );

    const res: any = await this.api.googleLogin(idToken)
    if (res.status === 'success') {
      console.log('Google login successful:', res);
      const sessionId = res.session.session_id;
      const userInfo = res.session;
      localStorage.setItem('session_id', sessionId);
      localStorage.setItem('user_info', JSON.stringify(userInfo));
      localStorage.setItem('auth_provider', 'google');
      window.location.href = '/';
    } else {
      console.error('Google login failed:', res);
      this.loginError.emit(this.resolveErrorType(res.message));
    }
  } catch (error) {
    console.error('Google login failed:', error);
    this.loginError.emit(this.resolveErrorType(error.message));
  }
}

// maps the exact backend response.message to a known error type used by the login screen
private resolveErrorType(message: string): string {

  console.log('Resolving error type for message:', message);
  switch (message) {
    case 'email not found':
      return 'user_not_found';
    case 'domain not allowed':
      return 'domain_not_allowed';
    default:
      return 'generic';
  }
}


}